const dateTimeRegexp = /(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\.[0-9]+)?(Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])?/gi
const dateRegexp = /(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])/gi
const hashtagRegexp = /#(\w|_)+/gi
const mentionRegexp = /\B@([\w-]+)/gim
const phoneRegexp = /\+?([\d|(][h|(\d{3})|.|\-|\d]{4,}\d)/gi
const RGBRegexp = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;

export {dateTimeRegexp, dateRegexp, hashtagRegexp, mentionRegexp, phoneRegexp, RGBRegexp}